import Vue from 'vue'

const isOnline = new Vue({
  data: function () {
    return {
      online: true
    }
  },
  methods: {
    updateStatus: function () {
      if (typeof window.navigator.onLine === 'undefined') {
        // If the browser doesn't support connection status reports
        // assume that we are online because most apps' only react
        // when they now that the connection has been interrupted
        this.online = true
      } else {
        this.online = window.navigator.onLine
      }

      if (this.$bus) {
        if (this.online === true) {
          this.$bus.$emit('online')
        } else {
          this.$bus.$emit('offline')
        }
      }
    }
  }
})

isOnline.updateStatus()

window.addEventListener('online', isOnline.updateStatus)
window.addEventListener('offline', isOnline.updateStatus)

export default function install(Vue) {
  Object.defineProperties(Vue, {
    isOnline: {
      get() {
        return isOnline.$data.online
      }
    }
  })

  Object.defineProperties(Vue.prototype, {
    $isOnline: {
      get() {
        return isOnline.$data.online
      }
    }
  })
}
